// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTableSettings = (payload = null) => http.post('apiToolPermission/getTableSettings', payload).then(getData);

export const get = (payload = null) => http.post('apiToolPermission/getRows', payload).then(getData);

export const getRow = (rowID) => http.get(`apiToolPermission/getRow&ID=${rowID}`).then(getData);

export const update = (row) => http.put('apiToolPermission/editDocument&ID=' + row.ID, row).then(getData);